import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    tenantId: string;
    profileImage?: string;
    phone?: string;
    bio?: string;
    created_at?: string;
    updated_at?: string;
  } | null;
}

// Initialize state
const initialState: AuthState = {
  isAuthenticated: false,
  token: null,
  user: null,
};

// Create the slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ token: string; user: AuthState['user'] }>) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      try {
        if (typeof window !== 'undefined') {
          localStorage.setItem('token', action.payload.token);
        }
      } catch (error) {
        console.error('Error during login:', error);
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      try {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('token');
        }
      } catch (error) {
        console.error('Error during logout:', error);
      }
    },
    updateUser: (state, action: PayloadAction<AuthState['user']>) => {
      state.user = action.payload;
    },
  },
});

export const { login, logout, updateUser } = authSlice.actions;
export default authSlice.reducer; 